/** Post Guard status definitions for (i) tooltip and product copy. */

export const POST_GUARD_STATUS_HELP = [
  {
    id: 'good',
    label: 'Looks good',
    description:
      'The post is synced and live, and every rule you set passed (or was left empty).',
  },
  {
    id: 'review',
    label: 'Review suggested',
    description:
      'Post is synced and live, but at least one rule failed — e.g. missing hashtag, blocked word, wrong format, or CTA.',
  },
  {
    id: 'not_live',
    label: 'Post not live',
    description:
      'Synced data is on file but the public link is missing or invalid — the post may have been removed.',
  },
  {
    id: 'awaiting_sync',
    label: 'Awaiting sync',
    description:
      'No Instagram data for this post yet. Use Refresh Instagram data — we pull caption, hashtags, media type, and metrics via the public link (no OAuth required).',
  },
];

export const POST_GUARD_INFO_LEAD =
  'Rule-based checks on synced posts. A synced post is always required (Instagram OAuth is optional). Optional rules: hashtags, handles, blocked words, format, and CTA.';
